export const attachSeries = (id, series) => `${series !== 'A' ? `${series}-` : ''}${id}`;
